import { ref, type Ref } from 'vue';
import type { ConfirmOptions } from '@/components/ConfirmDialog.vue';

const confirmDialogRef: Ref<{ show: (options: ConfirmOptions) => Promise<boolean> } | null> = ref(null);

export function useConfirmDialog() {
  return confirmDialogRef;
}

export function useConfirm() {
  const dialog = useConfirmDialog();

  const confirm = async (message: string, options?: Partial<ConfirmOptions>): Promise<boolean> => {
    if (!dialog.value) {
      console.warn('ConfirmDialog not mounted. Did you forget to add <ConfirmDialog ref="confirmDialog" /> to your app?');
      return window.confirm(message);
    }

    return dialog.value.show({
      message,
      ...options,
    });
  };

  const confirmDelete = async (itemName: string = '此项'): Promise<boolean> => {
    return confirm(`确定要删除${itemName}吗？此操作不可撤销。`, {
      title: '确认删除',
      type: 'danger',
      confirmText: '删除',
      cancelText: '取消',
    });
  };

  const confirmWarning = async (message: string, title?: string): Promise<boolean> => {
    const options: Partial<ConfirmOptions> = { type: 'warning' };
    if (title !== undefined) {
      options.title = title;
    }
    return confirm(message, options);
  };

  const confirmInfo = async (message: string, title?: string): Promise<boolean> => {
    const options: Partial<ConfirmOptions> = { type: 'info' };
    if (title !== undefined) {
      options.title = title;
    }
    return confirm(message, options);
  };

  return {
    confirm,
    confirmDelete,
    confirmWarning,
    confirmInfo,
  };
}
